<template>
  <a-drawer
      :title="title"
      :placement="placement"
      :closable="false"
      :visible="visible"
      :height="height"
      @close="onClose"
  >
    <slot></slot>
  </a-drawer>
</template>


<script>
export default {
  name: "my-drawer",
  components: {},
  props: {
    title: {
      type: String,
      default:"标题"
    },
    placement: {
      type: String,
      default:"right"
    },
    height:{
      type: Number,
      default:"300"
    },

  },
  computed: {},
  data() {
    return {
      visible: false,
    }
  },
  watch: {},
  methods: {
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    onChange(e) {
      this.placement = e.target.value;
    },
  },
}
</script>

<style scoped>

</style>
